var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BButton',{staticClass:"hover-gray",attrs:{"aria-label":_vm.$t('queryFilterBuilder.queryFilterRemoveButton'),"no-caret":"","variant":"link","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('FrIcon',{staticClass:"text-dark",attrs:{"outline":true,"name":"remove"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }